import PatientInformation from "@/customer/interfaces/PatientInformation";
import dateHelper from "@/core/helpers/dateHelper";

const ConsumerInformationService = () => {
    /**
     * The gender label based on the patient information.
     */
    const genderLabel = (information: PatientInformation): string => {
        switch (information.gender) {
            case 1:
                return 'Homme';
            case 2:
                return 'Femme';
            default:
                return "Genre non précisé";
        }
    };

    /**
     * Get the patient information summary.
     *
     * Output format: "Name, Gender, Age"
     */
    const informationSummary = (information: PatientInformation): string => {
        const name = information.name || "Nom non précisé";
        const gender = genderLabel(information);
        const age = dateHelper.age(information.birth_date);

        return `${name}, ${gender}, ${age}`;
    };

    return {
        genderLabel,
        informationSummary
    };
};

export default ConsumerInformationService();
